export default "__VITE_ASSET__DnHQ9Fcv__"